export const CheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M5 12L10 17L20 7"
        stroke="#E4775D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AddIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      width={20}
      height={20}
    >
      <path
        fill="#E8E9EE"
        d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z"
      />
    </svg>
  );
};

export const ArrowDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2071 8.24992C18.8166 7.8594 18.1834 7.8594 17.7929 8.24992L12 14.0428L6.20711 8.24992C5.81658 7.8594 5.18342 7.8594 4.79289 8.24992C4.40237 8.64044 4.40237 9.27361 4.79289 9.66413L10.5858 15.457C11.3668 16.2381 12.6332 16.2381 13.4142 15.457L19.2071 9.66414C19.5976 9.27361 19.5976 8.64045 19.2071 8.24992Z"
        fill="#9192A0"
      />
    </svg>
  );
};

export const DuplicatedArrowDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 448 512"
    >
      <path
        fill="#F7F7F7"
        d="M246.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 402.7 361.4 265.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-160 160zm160-352l-160 160c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7 361.4 73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"
      />
    </svg>
  );
};

export const TrumpIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M3.91667 13.7503C2.66667 14.8003 2.25 17.9169 2.25 17.9169C2.25 17.9169 5.36667 17.5003 6.41667 16.2503C7.00833 15.5503 7 14.4753 6.34167 13.8253C6.01776 13.5161 5.59108 13.3375 5.14352 13.3236C4.69597 13.3098 4.25906 13.4617 3.91667 13.7503Z"
        stroke="#E4775D"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.166 12.4996L7.66602 9.99956C8.10947 8.84908 8.66785 7.74627 9.33268 6.70789C10.3037 5.15538 11.6557 3.8771 13.2602 2.99463C14.8647 2.11217 16.6682 1.65486 18.4993 1.66622C18.4993 3.93289 17.8493 7.91622 13.4993 10.8329C12.4468 11.4985 11.3301 12.0568 10.166 12.4996Z"
        stroke="#E4775D"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.66667 10.0004H3.5C3.5 10.0004 3.95833 7.47542 5.16667 6.66709C6.51667 5.76709 9.33333 6.66709 9.33333 6.66709"
        stroke="#E4775D"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.166 12.5007V16.6673C10.166 16.6673 12.691 16.209 13.4993 15.0007C14.3993 13.6507 13.4993 10.834 13.4993 10.834"
        stroke="#E4775D"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M2.5 5H17.5"
        stroke="#F14437"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8327 5V16.6667C15.8327 17.5 14.9993 18.3333 14.166 18.3333H5.83268C4.99935 18.3333 4.16602 17.5 4.16602 16.6667V5"
        stroke="#F14437"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66602 5.00033V3.33366C6.66602 2.50033 7.49935 1.66699 8.33268 1.66699H11.666C12.4993 1.66699 13.3327 2.50033 13.3327 3.33366V5.00033"
        stroke="#F14437"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33398 9.16699V14.167"
        stroke="#F14437"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.666 9.16699V14.167"
        stroke="#F14437"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
